import React from 'react';
import { useSiteSettings } from '@/contexts/settings-context';
import styles from './mobile-footer.module.css';

export const MobileFooter: React.FC = () => {
  const { site } = useSiteSettings();

  if (!site.icp) return null;

  return (
    <footer className={styles.footer}>
      <p className={styles.icp} dangerouslySetInnerHTML={{ __html: site.icp }} />
      <p className={styles.copyright}>© {new Date().getFullYear()} {site.title}</p>
    </footer>
  );
};

export default MobileFooter;
